import { clamp } from '@sketch/utils'
import { useBreakpoint } from '../Breakpoint'
import { DefaultTheme, useTheme } from 'styled-components'

const getDefaultSidebarWidth = (isMobile: boolean, theme: DefaultTheme) => {
  if (!isMobile) {
    return theme.sidebar.leftWidth
  }

  const screenWidth = document.documentElement.clientWidth
  return clamp(
    screenWidth - theme.sidebar.defaultPaddingForTouchDevices,
    theme.sidebar.leftWidth,
    theme.sidebar.leftMaxWidth
  )
}

export function useDefaultSidebarWidth() {
  const isMobile = !useBreakpoint('xs')
  const theme = useTheme()

  return getDefaultSidebarWidth(isMobile, theme)
}
